


const PageThree = () => {
  return (
    <>
      <div className="flex items-start space-x-4">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-8 h-8 object-contain mt-2"
        />
        <div>
          <p className="text-xl font-bold text-foreground">Shadow Bro</p>
          <p className="text-xl text-foreground">Cipher unpassed. Tokenless. Unverified.</p>
        </div>
      </div>
      
      <div className="flex items-start space-x-4 mt-4">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-8 h-8 object-contain mt-2"
        />
        <div>
          <p className="text-xl font-bold text-foreground">Initiated Bro</p>
          <p className="text-xl text-foreground">Cipher complete. BroCode claimed. BroScore active.</p>
        </div>
      </div>
      
      <div className="flex items-start space-x-4 mt-4">
        <img 
          src="/lovable-uploads/clr_4.png" 
          alt="Bromentum Logo" 
          className="w-8 h-8 object-contain mt-2"
        />
        <div>
          <p className="text-xl font-bold text-foreground">BROMETHEUS</p>
          <p className="text-xl text-foreground">5,000 BroScore or 100,000 TOP1 burned.</p>
          <p className="text-xl text-foreground">Icon. War general. Walking proof.</p>
        </div>
      </div>
      
      <p className="text-xl mt-6 text-foreground">Ranks unlock access, rituals, respect, and risk.</p>
      <p className="text-xl text-foreground">Ascend or decay.</p>
    </>
  );
};

export default PageThree;
